import React from "react";
import { EmailContentProps } from "../types/EmailContent.interface";
import { RFxMailLayout } from "../components/RFxMailLayout";
import { AdditionalMessageDisplay } from "../components/AdditionalMessageDisplay";
import { ButtonLink } from "../components/ButtonLink";

export const OnboardingSubmissionSuccessfulEmailContent: React.FC<
	EmailContentProps
> = ({ rfxMail }) => {
	const emailData = rfxMail?.emailData;

	if (!emailData) {
		return null;
	}

	const $owner_company_name = emailData.owner_company_name;

	return (
		<RFxMailLayout
			$supplier_contact_name={emailData.supplier_contact_name}
			$contact={emailData.contact}
			rfx_type={emailData.rfx_code}
			project_name={emailData.project_name}
			rfx_title={emailData.rfx_title}
			isOnboarding={true}
		>
			<tr>
				<td
					style={{
						fontFamily: "Arial, sans-serif",
						fontSize: "16px",
						lineHeight: "24px",
						color: "#374151",
						paddingBottom: "20px",
					}}
				>
					Congratulations!{" "}
					<span className="bold">
						{$owner_company_name ?? "[RFx Creator Company Name]"}
					</span>{" "}
					has reviewed your submission and approved your company as an{" "}
					<span className="bold italic">
						Onboarded & Pre-Qualified Supplier
					</span>{" "}
					via <span className="bold">Procuracon</span>. .
				</td>
			</tr>
			<tr>
				<td
					style={{
						fontFamily: "Arial, sans-serif",
						fontSize: "16px",
						lineHeight: "24px",
						color: "#374151",
						paddingBottom: "20px",
					}}
				>
					This means your business has met the necessary onboarding and
					pre-qualification requirements and is now ready to be considered for
					upcoming tender opportunities.
					<span className="bold">
						{$owner_company_name ?? "[RFx Creator Company Name]"}
					</span>{" "}
					looks forward to partnering with you to help deliver and manage their
					projects and assets successfully.
				</td>
			</tr>
			<tr>
				<ButtonLink isOnboarding={true} />
			</tr>
			<tr>
				<td>
					Thank you for taking the time to complete the onboarding and
					pre-qualification process, and for being part of the Procuracon
					network.
				</td>
			</tr>
		</RFxMailLayout>
	);
};
